module.exports = __webpack_public_path__ + "img/icon_GoHere_s@2x.222904af.png";